import { render, staticRenderFns } from "./HeaderLogo.vue?vue&type=template&id=5feff954"
import script from "./HeaderLogo.vue?vue&type=script&lang=js"
export * from "./HeaderLogo.vue?vue&type=script&lang=js"
import style0 from "./HeaderLogo.vue?vue&type=style&index=0&id=5feff954&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports